import * as React from 'react'

function SvgComponent(props: any) {
    return (
        <svg
            width={93}
            height={110}
            viewBox='0 0 93 110'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M16.982 62.657v-10.72c0-2.951 2.486-5.437 5.438-5.437h10.72M41.218 46.5h10.72c2.951 0 5.437 2.486 5.437 5.437v10.72M57.375 70.735v10.72c0 2.952-2.486 5.438-5.438 5.438h-10.72M33.14 86.892H22.42c-2.952 0-5.438-2.485-5.438-5.437v-10.72'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M71.357 16.982H3v90.107h68.357V16.982z'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M71.357 40.286C81.653 40.286 90 31.939 90 21.643 90 11.347 81.653 3 71.357 3c-10.296 0-18.643 8.347-18.643 18.643 0 10.296 8.347 18.643 18.643 18.643z'
                fill='#fff'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M63.59 20.089l5.437 5.437 10.098-10.098'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
            <path
                d='M49.452 24.75H24.905c-1.864 0-3.262-1.398-3.262-3.262v-4.506h31.071v4.506c0 1.864-1.398 3.262-3.262 3.262z'
                fill='#300038'
                stroke='#000'
                strokeWidth={5}
                strokeMiterlimit={10}
            />
        </svg>
    )
}

export default SvgComponent
